module.exports = __webpack_public_path__ + "img/lbt_2.c7be3858.jpg";